import { ReactNode } from "react";
import { Tooltip } from "antd";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

interface FormItemProps {
  label?: string,
  top?: boolean,
  required?: boolean,
  tooltip?: string,
  children: ReactNode

}
const FormItem = ({ label, top, required = false, tooltip, children }: FormItemProps) => {
  return (
    <div
      className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start ${top ? "pt-0" : "sm:border-t"
        } sm:border-gray-200 py-5`}
    >
      <label
        htmlFor={`${label}`}
        className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
      >
        {label}{required && <span className="text-red-500 ml-1">*</span>}
        {tooltip && (
          <Tooltip title={tooltip}>
            <InformationCircleIcon className="h-4 w-4 ml-1 inline-block align-text-bottom text-gray-400" />
          </Tooltip>
        )}
      </label>

      <div className="mt-1 sm:mt-0 sm:col-span-2">
        {children}
      </div>
    </div>
  );
};
export default FormItem;
